import { render } from "./BillingHistory.vue?vue&type=template&id=16ecb365&scoped=true"
import script from "./BillingHistory.vue?vue&type=script&lang=js"
export * from "./BillingHistory.vue?vue&type=script&lang=js"

import "./BillingHistory.vue?vue&type=style&index=0&id=16ecb365&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16ecb365"]])

export default __exports__